import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import PermIdentityOutlined from '@mui/icons-material/PermIdentityOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import { useTheme } from '@mui/material/styles';
import { ImageField, LinkField } from '@sitecore-jss/sitecore-jss-react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { SIGN_OUT } from '../../lib/constant';
import Logo from '../DTP/HeaderNavigation/Logo';
import {
  AppBarButton,
  AppBarLink,
  AppBarMenuItem,
  AppBarMenuLink,
  AppBarProfileButton,
  AppBarProfileLink,
} from './HCPHeaderNavigation.style';
import { ChildLinkItem } from './HCPHeaderNavigation.types';
import { scrollToSectionPath } from '../../lib/utils/common';

const fallbackLink: LinkField = { value: { href: '', text: '' } };
const fallbackImg: ImageField = { value: { src: '' } };
const HCPDesktopNav: React.FC<any> = (props) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorElProfile, setAnchorElProfile] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const profileOpen = Boolean(anchorElProfile);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.currentTarget.getAttribute('id') === 'profile-button') {
      setAnchorElProfile(event.currentTarget);
      return;
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    anchorEl && setAnchorEl(null);
    anchorElProfile && setAnchorElProfile(null);
  };

  const ChildMenu: React.FC<{
    navLinks: Array<ChildLinkItem>;
    anchorElm: any;
    id: string;
    btnId: string;
    isOpen: boolean;
    fieldItem?: any;
  }> = (propsChildMenu) => {
    const isNotificationBannerOpen = useSelector(
      (state: RootState) => state?.config?.isNotificationBannerOpen
    );

    const [currentHash, setCurrentHash] = useState<any>('');

    useEffect(() => {
      if (typeof window !== 'undefined') {
        setCurrentHash(window.location.hash);
        const handleHashChange = () => {
          setCurrentHash(window.location.hash);
        };
        window.addEventListener('hashchange', handleHashChange);
        return () => {
          window.removeEventListener('hashchange', handleHashChange);
        };
      } else {
        return;
      }
    }, []);

    useEffect(() => {
      const margin = isNotificationBannerOpen ? 100 : 0;
      scrollToSectionPath(currentHash, margin, 1000);
    }, [currentHash]);

    const onClickMenuItem = (e: any, item: any) => {
      e.preventDefault();
      if (item.name === SIGN_OUT) {
        props?.openProfileModal({
          open: false,
          profileFields: propsChildMenu?.fieldItem || item.fields,
          signOutOpen: true,
        });
        handleClose();
        return;
      }
      try {
        if (item) {
          const anchorVal = item?.fields?.link?.value?.anchor;
          const linkURL = item?.fields?.link?.value?.href;
          const targetElement = document.getElementById(anchorVal);
          const margin = isNotificationBannerOpen ? 100 : 0;
          if (targetElement) {
            const offsetTop = targetElement.offsetTop;
            window.scroll({
              top: offsetTop - margin,
              left: 0,
              behavior: 'smooth',
            });
          } else if (anchorVal != '' && linkURL != '') {
            window.location.href = linkURL + '#' + anchorVal;
          } else {
            window.location.href = linkURL;
          }
        }
      } catch (error) {
        console.error(error);
      }
      handleClose();
    };

    if (Array.isArray(propsChildMenu.navLinks) && propsChildMenu.navLinks.length > 0) {
      return (
        <Menu
          sx={{
            marginTop: '0px',
            minWidth: '180px',
            marginLeft: '15px',
          }}
          id={`menu-${propsChildMenu.id}`}
          anchorEl={propsChildMenu.anchorElm}
          open={propsChildMenu.isOpen}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': propsChildMenu.btnId,
          }}
        >
          {propsChildMenu.navLinks.map((item, index) => {
            return (
              <AppBarMenuItem key={index} onClick={(event) => onClickMenuItem(event, item)}>
                {item.name === SIGN_OUT ? (
                  <AppBarProfileLink onClick={(event) => onClickMenuItem(event, item)}>
                    {item.fields?.link?.value.text}{' '}
                  </AppBarProfileLink>
                ) : (
                  <AppBarLink
                    field={item.fields?.link || fallbackLink}
                    onClick={(event) => onClickMenuItem(event, item)}
                  ></AppBarLink>
                )}
              </AppBarMenuItem>
            );
          })}
        </Menu>
      );
    }
    return <></>;
  };

  return (
    <Box
      id="hcp-desktop-header-navigation"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        width: '100%',
        marginLeft: '6rem',
        marginRight: '5rem',
        [theme.breakpoints.down(1150)]: {
          marginLeft: '4rem',
          marginRight: '3rem',
        },
      }}
    >
      <Box>
        <Logo
          id={'hcp-desktop-logo'}
          imageField={props.headerLogo || fallbackImg}
          ariaLabel={props?.headerLogoAriaLabel?.value as string}
        />
      </Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        {props.navigationLinks &&
          props.navigationLinks.map((item: any, index: number) => {
            const childNavList = item.fields?.childNavList;
            const isProfileLinkAsModal = item.fields?.hasOwnProperty('myProfile');
            if (isProfileLinkAsModal) {
              if (!props.isAuthenticated) {
                return (
                  <AppBarButton
                    key={index}
                    onClick={() =>
                      props?.openProfileModal({ open: true, profileFields: item.fields })
                    }
                  >
                    {item.fields?.link?.value.text || ''}
                  </AppBarButton>
                );
              }

              return (
                <>
                  <AppBarProfileButton
                    id="profile-button"
                    aria-controls={profileOpen ? `menu-${item?.id}` : undefined}
                    aria-haspopup="true"
                    aria-expanded={profileOpen ? 'true' : undefined}
                    onClick={handleClick}
                    startIcon={
                      <Avatar alt="Profile" sx={{ width: 35, height: 35 }}>
                        <PermIdentityOutlined />
                      </Avatar>
                    }
                  >
                    {item.fields?.link?.value.text || ''}
                    {profileOpen ? <ArrowDropUp /> : <ArrowDropDown />}
                  </AppBarProfileButton>
                  <ChildMenu
                    navLinks={item.fields?.childNavList || []}
                    anchorElm={anchorElProfile}
                    id={item?.id}
                    btnId="profile-button"
                    isOpen={profileOpen}
                    fieldItem={item.fields}
                  />
                </>
              );
            }

            if (Array.isArray(childNavList) && childNavList.length > 0) {
              return (
                <>
                  <AppBarButton
                    id="basic-button"
                    aria-controls={open ? `menu-${item?.id}` : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                  >
                    {item.fields?.link?.value.text || ''}
                    {open ? <ArrowDropUp /> : <ArrowDropDown />}
                  </AppBarButton>
                  <ChildMenu
                    navLinks={item.fields?.childNavList || []}
                    anchorElm={anchorEl}
                    id={item?.id}
                    btnId="basic-button"
                    isOpen={open}
                  />
                </>
              );
            }
            return <AppBarMenuLink field={item.fields?.link || fallbackLink} key={index} />;
          })}
      </Box>
    </Box>
  );
};
export default HCPDesktopNav;
